import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'
import {
  isK5SiteSelection,
  isMsSiteSelection,
  isMiddleSchoolUrl,
  isFamilyResourcesPageInProgramFlex,
  isHighSchoolUrl,
} from 'utils/routing/routeHelpers'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-20164-k5-site-selection'],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    const subscribedFlagsWithMsSiteSelectionTrue = {
      ...subscribedFlags,
      'feature_LEARN-20108-ms-site-selection': true,
    }

    return (
      isMiddleSchoolUrl() ||
      isHighSchoolUrl() ||
      isFamilyResourcesPageInProgramFlex() ||
      isK5SiteSelection(_, subscribedFlags) ||
      isMsSiteSelection(_, subscribedFlagsWithMsSiteSelectionTrue)
    )
  },
})

export default FlagToggler
